<template>
    <div>
        <v-row>                
            <v-col cols="12">Total number of complaints <span class="ml-2 mr-2"><b>{{overview.numberOfClaims}}</b></span>  total amount claimed <span class="ml-2"><b>€ {{ overview.claimedAmount }}</b></span></v-col>    
        </v-row>        
        <div v-if="overview.numberOfClaims > 0">
            <v-row>
                <v-col cols="12">
                    <v-data-table 
                            flat dense 
                            :headers="getHeaders()"
                            :items="overview.amounts" 
                            :disable-pagination=true 
                            hide-default-footer>
                        <template v-slot:item="amounts">
                            <tr>
                                <td>{{amounts.item.typeDescription}}</td>                                                    
                                <td align="right">{{amounts.item.numberOfComplaints}}</td> 
                                <td align="right">{{amounts.item.caused}}</td>
                                <td align="right">{{amounts.item.complaintValue}}</td>
                                <td align="right">{{amounts.item.claimedAmount}}</td>
                            </tr>
                        </template>
                    </v-data-table>                                  
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            overview: Object,
        },     
        components: {            
        },      
        data() {
            return {
            }
        },
        methods: {    
            getHeaders(){
                return [
                    {text: "Role", value: "type", align: "start", sortable: false},
                    {text: "No. complaints", value: "numberOfComplaints", align: "end", sortable: false},
                    {text: "Involved/cause", value: "caused", align: "end", sortable: false},
                    {text: "Claimed", value: "complaintValue", align: "end", sortable: false},
                    {text: 'Compensation', value: "claimedAmount", align: "end", sortable: false}
                ];
            }                
        }
    }
</script>

<style scoped>
td{
    vertical-align: top;
    border-top: 3px solid transparent;    
}

</style>